import {
  Card,
  LinearProgress,
  Typography,
  Box,
  darken,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';

export default function CourseCard({course}) {
  const theme = useTheme();
  const progress =
    course.totalLessons > 0 ? Math.round((course.completedLessons / course.totalLessons) * 100) : 0;

  return (
    <Link to={`/learning/${course.id}`}>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'row',
          p: 2,
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            backgroundColor: theme.palette.hover.main,
          },
          '&:active': {
            backgroundColor: darken(theme.palette.hover.main, 0.03),
          },
        }}
      >
        <Box
          sx={{
            width: '120px',
            height: '120px',
            backgroundColor: darken(theme.palette.hover.main, 0.2),
            borderRadius: 2,
            mr: 2,
            objectFit: 'cover',
          }}
          component={course.image && 'img'}
          src={course.image}
          alt={course.title}
        />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {course.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, display: '-webkit-box', WebkitLineClamp: course.completedLessons ? 2 : 4, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {course.description}
          </Typography>
          {course.completedLessons && (
            <Box sx={{ mt: 'auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mr: 1 }}
                >
                  {progress}% abgeschlossen
                </Typography>
                <Typography variant="body2" sx={{ ml: 'auto' }}>
                  {course.completedLessons}/{course.totalLessons} Lektionen
                </Typography>
              </Box>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
          )}
        </Box>
      </Card>
    </Link>
  );
}
